var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": _vm.desc
    }
  }, [_c('ul', {
    staticClass: "pagination",
    class: [_vm.size ? ("pagination-" + _vm.size) : '', ("justify-content-" + _vm.align)]
  }, [(_vm.showFirst) ? _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.prevDisabled
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "First",
      "tabindex": _vm.prevDisabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.to(1)
      }
    }
  }, [_vm._t("first"), _vm._v(" "), (!_vm.$slots.first) ? [_vm._v(_vm._s(_vm.firstText))] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showPrev) ? _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.prevDisabled
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "Previous",
      "tabindex": _vm.prevDisabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prev()
      }
    }
  }, [_vm._t("prev"), _vm._v(" "), (!_vm.$slots.prev) ? [_vm._v(_vm._s(_vm.prevText))] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageQueue), function(page) {
    return _c('li', {
      staticClass: "page-item",
      class: {
        active: _vm.value === page
      }
    }, [(page === '...') ? _c('span', {
      staticClass: "page-link"
    }, [_vm._v("...")]) : _c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.to(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), (_vm.showNext) ? _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.nextDisabled
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "Next",
      "tabindex": _vm.nextDisabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._t("next"), _vm._v(" "), (!_vm.$slots.next) ? [_vm._v(_vm._s(_vm.nextText))] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showLast) ? _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.nextDisabled
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "Last",
      "tabindex": _vm.nextDisabled ? -1 : 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.to(_vm.pages)
      }
    }
  }, [_vm._t("last"), _vm._v(" "), (!_vm.$slots.last) ? [_vm._v(_vm._s(_vm.lastText))] : _vm._e()], 2)]) : _vm._e()], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c0014b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/Pagination.vue
// module id = 185
// module chunks = 19